<template>
  <div id="users_consents_list">
    <div class="right div--button ma-2">
      Filtered rows: {{ users_length }}
    </div>
    <b-table :current-page="currentPage"
             :fields="fields"
             :items="users"
             :per-page="perPage"
             class="table-responsive"
             head-variant="light"
             hover
             outlined
             responsive
             striped>

      <template v-slot:top-row="{fields}">
        <proposal-filter :id="id"
                         v-model="users"
                         :fields="fields"
                         :not-include-key="['actions','ordinalNumber']"/>
      </template>

      <template v-slot:cell(ordinalNumber)="row">
        <base-column-ordinal-number v-bind="{index: row.index, perPage: perPage, currentPage: currentPage}"/>
      </template>

      <template v-slot:cell(consent_data.promotion.states.state)="row">
        <div v-if="hasProperty(row.item.consent_data, 'promotion')"
             class="center">
          <b-form-checkbox v-model="row.item.consent_data.promotion.states.state"
                           :disabled="true"/>
        </div>
        <div v-else
             class="center">
          <b-form-checkbox :disabled="true"
                           v-bind:value="false"/>
        </div>
      </template>

      <template v-slot:cell(consent_data.register.states.state)="row">
        <div v-if="hasProperty(row.item.consent_data, 'register')"
             class="center">
          <b-form-checkbox v-model="row.item.consent_data.register.states.state"
                           :disabled="true"/>
        </div>
        <div v-else
             class="center">
          <b-form-checkbox :disabled="true"
                           v-bind:value="false"/>
        </div>
      </template>

      <template v-slot:cell(consent_data.team_share.states.state)="row">
        <div v-if="hasProperty(row.item.consent_data, 'team_share')"
             class="center">
          <b-form-checkbox v-model="row.item.consent_data.team_share.states.state"
                           :disabled="true"/>
        </div>
        <div v-else
             class="center">
          <b-form-checkbox :disabled="true"
                           v-bind:value="false"/>
        </div>
      </template>

      <template v-slot:cell(consent_data.communication.states.state)="row">
        <div v-if="hasProperty(row.item.consent_data, 'communication')"
             class="center">
          <b-form-checkbox v-model="row.item.consent_data.communication.states.state"
                           :disabled="true"/>
        </div>
        <div v-else
             class="center">
          <b-form-checkbox :disabled="true"
                           v-bind:value="false"/>
        </div>
      </template>

      <template v-slot:cell(consent_data.wishes.states.state)="row">
        <div v-if="hasProperty(row.item.consent_data, 'wishes')"
             class="center">
          <b-form-checkbox v-model="row.item.consent_data.wishes.states.state"
                           :disabled="true"/>
        </div>
        <div v-else
             class="center">
          <b-form-checkbox :disabled="true"
                           v-bind:value="false"/>
        </div>
      </template>

      <template v-slot:cell(actions)="row">
        <base-icon-button-send title="Go to user details"
                               @click="go_to_user(row.index)"/>
      </template>

    </b-table>

    <b-table-footer v-model="is_busy"
                    :current-page="currentPage"
                    :data-length="users_length"
                    :per-page="perPage"
                    @change-page="change_page">
      <template v-slot>
        <base-per-page-input v-model="perPage"/>
      </template>
    </b-table-footer>
  </div>
</template>

<script>
  import BaseColumnOrdinalNumber from '@/components/base-components/BaseColumnOrdinalNumber';
  import BaseIconButtonSend from '@/components/base-components/base-icons/BaseIconButtonSend';
  import BasePerPageInput from '@/components/base-components/BasePerPageInput';
  import BTableFooter from '@/components/BTableFooter';
  import ProposalFilter from '@/components/ProposalFilter';

  export default {
    name: 'users_consents_list',
    components: {
      BaseColumnOrdinalNumber,
      BaseIconButtonSend,
      BasePerPageInput,
      BTableFooter,
      ProposalFilter,
    },
    computed: {
      users_length() {
        return this.users.length;
      },
    },
    props: {
      fields: {
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {
        is_busy: false,
        users: [],
        currentPage: 1,
        perPage: 20,
        id: 1,
      };
    },
    methods: {
      load_data() {
        this.toggle_busy();
        this.axios.get('/users/consents')
          .then((response) => {
            this.users = response.data;
            this.$emit('setup-proposal', this.users);
            this.toggle_busy();
          });
      },
      change_page(val) {
        this.currentPage = val;
      },
      toggle_busy() {
        this.is_busy = !this.is_busy;
      },
      calculate_row_index(index) {
        return index + (this.perPage * (this.currentPage - 1));
      },
      go_to_user(index) {
        const idx = this.calculate_row_index(index);
        const user_id = this.getId(this.users[idx]);
        this.$router.push(`/operational/users/${user_id}/0`);
      },
    },
    created() {
      this.load_data();
    },
  };
</script>

<style scoped>
  .center {
    text-align: center;
  }
</style>
